<template>

<v-content class="mt-12">
    <v-card
        width=600
        flat
        dark
        class="mx-auto blueMain">
        <div class="text-center my-2 blueGrey--text">
            <v-icon class=" blueGrey--text">people</v-icon>
            Сотрудники
        </div>
        

<!-- Shops card -->
        <v-card
            dark
            class="blueDark">

            <v-expansion-panels
                accordion
                dark
                flat
                focusable>

                <v-expansion-panel
                    v-for="shopid in totalInfo.shoplist"
                    :key="shopid"
                    class="blueDark">
                    <v-expansion-panel-header>
                        <div class="">
                            {{shopinfo[shopid].shopname.split(' ')[0]}}
                        </div>
                        <div class="orangeMain--text">
                            {{shopinfo[shopid].shopname.split(' ').slice(1,).join(' ')}}
                        </div>
                    </v-expansion-panel-header>

                    <v-lazy
                        :options="{ threshold: .5 }"
                        transition="fade-transition">

                        <Sellers :shopid="shopid"/>

                    </v-lazy>

                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-card>
</v-content>

</template>

<script>

import Sellers from './shop-sellers'
import {mapState} from 'vuex';

export default {
name: 'SellerList',
components: {
    Sellers
},

data: () => ({
}),

computed: {
    ...mapState(['totalInfo', 'shopinfo']), 

},

methods: {
},

created: function() {
}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
